import { useSearchParams } from "react-router-dom";
import Layout from "@/components/Layout";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { GraduationCap, UserCog } from "lucide-react";
import AdminAttendance from "@/pages/AdminAttendance";
import AdminTeacherAttendance from "@/pages/AdminTeacherAttendance";

const VALID_TABS = ["students", "teachers"];

export default function AdminAttendanceHub() {
  const [params, setParams] = useSearchParams();
  const requested = params.get("tab");
  const active = VALID_TABS.includes(requested) ? requested : "students";
  const onChange = (val) => setParams({ tab: val }, { replace: true });

  return (
    <Layout>
      <div className="mb-6">
        <div className="text-xs uppercase tracking-[0.2em] text-slate-400 mb-2">Administration</div>
        <h1 className="text-3xl font-bold text-slate-900 dark:text-slate-100" style={{ fontFamily: "Outfit" }}>Attendance</h1>
        <p className="text-slate-500 dark:text-slate-400 mt-1">Student and staff attendance in one place.</p>
      </div>

      <Tabs value={active} onValueChange={onChange} className="w-full">
        <TabsList className="h-auto flex-wrap gap-1 bg-slate-100 dark:bg-slate-800/60" data-testid="attendance-hub-tabs">
          <TabsTrigger value="students" data-testid="attendance-tab-students" className="gap-1.5">
            <GraduationCap className="h-4 w-4" /> Students
          </TabsTrigger>
          <TabsTrigger value="teachers" data-testid="attendance-tab-teachers" className="gap-1.5">
            <UserCog className="h-4 w-4" /> Teachers
          </TabsTrigger>
        </TabsList>
        <TabsContent value="students" className="mt-6"><AdminAttendance embedded /></TabsContent>
        <TabsContent value="teachers" className="mt-6"><AdminTeacherAttendance embedded /></TabsContent>
      </Tabs>
    </Layout>
  );
}
